@if (show) {
  <div class="pro-tag" matTooltip="{{ 'subscription.new-usage.upgrade-needed' | translate }}" matTooltipPosition="right" [matTooltipDisabled]="hideTooltip">
    PRO
  </div>
}
@if (showDisabled) {
  <div
    class="pro-tag pro-tag-disabled"
    matTooltip="{{ 'subscription.new-usage.included' | translate }}"
    matTooltipPosition="right"
    [matTooltipDisabled]="hideTooltip">
    PRO
  </div>
}
